///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Component, DestroyRef, inject, OnInit } from '@angular/core';
import { LinkFeature } from '../../../entities/link/link-feature';
import { GtthHistoryService } from '../../../engine/history-service';
import { GtthFreezeSelectedLinksCommand } from '../../../engine/commands/link/freeze-selected-links-command';
import { SuiActionConfig } from '../../../../../shared/sui-lib-customisations/sui-action/sui-action-config';
import { TopologyLinkTypeEnum } from '../../../../../services/project-socket/dto/topology-types.model';
import { SuiActionControlComponent, SuiSelectEnumControlComponent, SuiTypeEnum } from '@siklu/sui-lib/infrastructure';
import { LinkInfoStateService } from '../link-info-state.service';
import { EMPTY, of } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
    selector: 'winde-los-info-panel',
    templateUrl: 'los-info-panel.component.html',
    styleUrls: ['../../entities-info-window.scss'],
    imports: [SuiSelectEnumControlComponent, SuiActionControlComponent]
})
export class LosInfoPanelComponent implements OnInit {
    public readonly link: LinkFeature;

    public linkTypeConfig: SuiTypeEnum<TopologyLinkTypeEnum>;
    public unfreezeAction: SuiActionConfig;
    public disableAction: SuiActionConfig;
    public deleteAction: SuiActionConfig;
    private readonly destroyRef = inject(DestroyRef);

    constructor(
        public readonly historyService: GtthHistoryService,
        public readonly linkInfoStateService: LinkInfoStateService
    ) {
        this.link = this.linkInfoStateService.getLink();
    }

    ngOnInit(): void {
        this.linkTypeConfig = new SuiTypeEnum<TopologyLinkTypeEnum>(
            this.link.getLinkType(),
            LinkFeature.possibleLosStates,
            'TopologyLinkTypeEnum'
        );
        this.linkTypeConfig.isAlignedStyles = true;
        this.linkTypeConfig.dropdownConfig.panelClass = 'entities-info-select-dropdown';
        this.linkTypeConfig.valueChanges$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(() => {
            this.linkInfoStateService.changeLosType(this.linkTypeConfig.getValue());
        });

        this.unfreezeAction = new SuiActionConfig('Unfreeze link');
        this.unfreezeAction.callback = () => of(this.unfreeze());

        this.initLosDisableControlIfPossible();

        this.deleteAction = new SuiActionConfig('Delete');
        this.deleteAction.callback = () => of(this.linkInfoStateService.deleteLink());
    }

    async unfreeze(): Promise<void> {
        const freezeCommand = this.historyService.command(GtthFreezeSelectedLinksCommand).createFromLinksList([this.link], false, false);
        await this.historyService.doCommand(freezeCommand);
        return Promise.resolve();
    }

    private initLosDisableControlIfPossible(): void {
        if (this.link.getLinkIsDisabled() && (!this.link.getFromStation().isEnabled() || !this.link.getToStation().isEnabled())) {
            return;
        }

        this.disableAction = new SuiActionConfig('');
        this.disableAction.callback = () => {
            this.linkInfoStateService.setLosDisabled(!this.link.getLinkIsDisabled());
            this.disableAction.btnText = this.link.getLinkIsDisabled() ? 'Enable link' : 'Disable link';
            return EMPTY;
        };
        this.disableAction.btnText = this.link.getLinkIsDisabled() ? 'Enable link' : 'Disable link';
    }
}
